
module.exports = [
  {
    name: "Basic Email Template",
    description: `
      A simple responsive email template that clearly directs the user to click the review form link.
      Has a prominent white box container for logo overlaid onto the blue header.
    `,
    content: require('./samples/basicEmailTemplate.hbs'),
    templateType: "email",
    previewImg:  "/images/reviewBuilder/emailTemplate/BasicEmail.jpg",
    dynamicFields: {
      'image:logo' : "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
      'text:heading': 'Your opinion matters!',
      'text:subheading': 'Click below to submit your review',
      'text:buttonText': 'Submit Review',
      'text:leftHeading': 'Help us improve',
      'text:leftContent': 'Your suggestions are important to us',
      'text:rightHeading': 'Thanks for visiting!',
      'text:rightContent': 'We hope you enjoyed your experience with us.',
      'text:copyright': '© 2016 Your Company Here, All Rights Reserved',
      'text:streetAddress': '1234 Your Address Here'
    }
  },
  {
    name: "Sentiment Email Template",
    description: `
      Allows for autosubmission based on sentiment. Clicking 'Very Satisfied' submits a 5 star rating 
      and redirects to Thank You page. Clicking the other two buttons redirects to the regular form.
    `,
    content: require('./samples/sentimentEmailTemplate.hbs'),
    templateType: "email",
    previewImg:  "/images/reviewBuilder/emailTemplate/SentimentEmail.jpg",
    dynamicFields: {
      'image:logo' : "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
      'text:header': 'Your opinion matters!',
      'text:subheader': 'We hope you enjoyed your recent experience with us. Please share your feedback to help us improve.',
      'text:rateExperience': 'How would you rate your experience?',
      'text:verySatisfied': 'Very Satisfied',
      'text:somewhatSatisfied': 'Somewhat Satisfied',
      'text:notSatisfied': 'Not Satisfied',
      'text:verySatisfiedSubtext': 'Excellent! I would definitely come back.',
      'text:somewhatSatisfiedSubtext': 'It was ok, but could have been better.',
      'text:notSatisfiedSubtext': 'Unfortunately, I wasn’t happy with it at all.',
      'text:reserved': '@2017, All Rights Reserved',
      'text:address': 'Your Address Goes Here',
    }
  },
  {
    name: "Star Email Template",
    description: `
      Allows for autosubmission based on star rating. Clicking either the 4 or 5 stars submits a corresponding rating 
      and redirects to Thank You page. Clicking on 1, 2, or 3 stars redirects to regular form.
    `,
    content: require('./samples/starEmailTemplate.hbs'),
    templateType: "email",
    previewImg:  "/images/reviewBuilder/emailTemplate/StarEmail.jpg",
    dynamicFields: {
      'image:logo' : "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
      'text:header': 'We value your feedback!',
      'text:subheader': 'Thank you for your business. Please take a moment to let us know how we\'re doing.',
      'text:rateExperience': 'How would you rate your experience?',
      'text:select': '(Select 1-5 Stars)',
      'text:reserved': '@2017, All Rights Reserved',
      'text:address': 'Your Address Goes Here',
    }
  },
  {
    name: "NPS Email Template",
    description: `
      Allows for autosubmission based on NPS score. Clicking a score that is 9 or greater submits a corresponding score  
      and redirects to Thank You page. Clicking a number 8 or lower redirects to regular form.
    `,
    content: require('./samples/npsEmailTemplate.hbs'),
    templateType: "email",
    previewImg:  "/images/reviewBuilder/emailTemplate/NpsEmail.jpg",
    dynamicFields: {
      'image:logo' : "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
      'text:header': 'We value your feedback!',
      'text:subheader': 'To help us improve, please take a moment to let us know how we\'re doing by clicking on a number below.',
      'text:recommend': 'How likely are you to recommend our service to a friend or colleague?',
      'text:reserved': '@2017, All Rights Reserved',
      'text:address': 'Your Address Goes Here',
    }
  }
];
